export default __webpack_public_path__ + "static/media/Icon-Left_Arrow_Cold.37fcd88b.svg";